import React from "react"
import tw from "twin.macro"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import Container from "@structure/Container"
import ModalExit from "@components/ModalExit"
import CormedixLogo from "@images/shared/logo_cormedix.inline.svg"

const Footer = ({ ...props }) => {
  const triggerOneTrust = () => {
    if (window) {
      window?.OneTrust.ToggleInfoDisplay()
    }
  }

  const year = new Date().getFullYear();

  const styles = {
    links: tw`block font-kanit tracking-[0.005rem] mb-2 transition duration-300 lg:(mb-3.5) hover:(text-green)`,
  }

  return (
    <footer tw="py-12 relative text-white" {...props}>
      <StaticImage
        tw="z-10 w-full h-full !absolute top-0"
        alt=""
        src="../../images/shared/bg_footer.jpg"
      />
      <div tw="z-10 w-full h-full absolute left-0 top-0 bg-[linear-gradient(0deg, rgba(36, 0, 65, 1), rgba(36, 0, 65, 0.5) 100%)]"></div>
      <Container tw="z-20 relative">
        <div tw="lg:(grid grid-cols-12 gap-4)">
          <div tw="w-[235px] lg:(col-start-1 col-span-3)">
            <ModalExit
              triggerContent={
                <>
                  <span tw="sr-only">Cormedix.com</span>
                  <CormedixLogo role="img" aria-label="CorMedix logo" />
                </>
              }
              triggerStyles={[tw`block w-full`]}
              destinationUrl="https://www.cormedix.com"
            />
          </div>
          <div
            data-gtm="footer-menu"
            tw="py-6 border-b border-white lg:(border-0 col-start-8 col-span-2 py-0)"
          >
            <Link css={styles.links} to="/efficacy">
              Proven Efficacy
            </Link>
            <Link css={styles.links} to="/how-defencath-works">
              How DefenCath Works
            </Link>
            <Link css={styles.links} to="/safety">
              Safety
            </Link>
            <Link css={styles.links} to="/dosing-and-administration">
              Dosing and Administration
            </Link>
            <Link css={styles.links} to="/ordering-defencath">
            Ordering DefenCath
            </Link>
          </div>
          <div
            data-gtm="footer-menu"
            tw="py-6 border-b border-white lg:(border-0 col-start-11 col-span-2 py-0)"
          >
            <ModalExit
              triggerContent={"Contact Us"}
              triggerStyles={styles.links}
              destinationUrl="https://www.cormedix.com/contact/"
            />
            <Link css={styles.links} to="/terms-of-use">
              Terms of Use
            </Link>
            <Link css={styles.links} to="/privacy">
              Privacy Statement
            </Link>
            <Link css={styles.links} to="/unsubscribe">
              Unsubscribe
            </Link>
            {/* Placeholder */}
            <button
              id="ot-sdk-btn"
              data-id="cookie-settings-button"
              className="ot-sdk-show-settings-alt"
              onClick={() => triggerOneTrust()}
              css={styles.links}
            >
              Cookie Settings
            </button>
          </div>
        </div>
        <div tw="lg:(grid grid-cols-12 items-end gap-4)">
          <div tw="lg:(col-span-7 text-lg)">
            <div tw="pt-6 lg:(pt-0)">
              <p tw="mb-6 leading-[1.1] lg:(mb-2.5 leading-[1.2])">
                300 Connell Drive, 4th Floor, Suite 4200, Berkeley Heights,
                NJ&nbsp;07922
              </p>
              <p tw="mb-6 leading-[1.1] lg:(mb-2.5 leading-[1.2])">
              DEFENCATH, CORMEDIX, the CORMEDIX logo and CORMEDIX INC. are registered trademarks of CorMedix Inc. <br />
                &copy; {year} CorMedix Inc. All rights reserved.
              </p>
            </div>
            <div tw="pb-6 lg:(pb-0)">
              <p>MAT-0015 (V2.0) 04/25</p>
            </div>
          </div>
          <div tw="lg:(col-start-11 col-span-2)">
            <p tw="font-kanit tracking-[0.005rem]">
              Follow us on{" "}
              <ModalExit
                triggerContent={"LinkedIn"}
                triggerStyles={[
                  tw`font-extrabold underline transition duration-300 hover:(text-green)`,
                ]}
                destinationUrl="https://www.linkedin.com/company/cormedix-inc-/"
              />
            </p>
          </div>
        </div>
      </Container>
    </footer>
  )
}

export default Footer
